import { useContext, useEffect, useRef } from "react";
import { TechnologyContext } from "context/TechnologyContext";
import style from "./ElementyTechMenu.module.css";
import { ponumerArkusze } from "actions/ponumerArkusze";
import { useArkuszeOne } from "hooks/useArkuszeOne";
import { useProcesy } from "hooks/procesy/useProcesy";
import { CirclePlus, GitBranchPlus, ListOrdered, Plus, Sparkles } from "lucide-react";
export default function MenuElementyTech({ row }) {

  const techContext = useContext(TechnologyContext);

  const setElementyTech = techContext.setElementyTech;
  const elementyTech = techContext.elementyTech;
  const setShowProcesy = techContext.setShowProcesy;

  const {createProcesyFromArkuszONE} = useProcesy();
  const menuRef = useRef(null);

      useEffect(() => {
      // Jeśli menu jest zamknięte, nie dodajemy listenera
      if (!row.showMenu) return;
  
      const handleClickOutside = (event) => {
        // Sprawdzamy, czy kliknięcie nastąpiło POZA elementem przypisanym do menuRef
        if (menuRef.current && !menuRef.current.contains(event.target)) {
                       setElementyTech(elementyTech.map((t) => {
                      return {...t,
                        showMenu: false}
                    }));
        }
      };
  
      // Dodajemy listener w fazie przechwytywania (useCapture: true),
      // aby zapobiec problemom, gdy inne komponenty używają event.stopPropagation()
      document.addEventListener('mousedown', handleClickOutside);
  
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [row.showMenu]);


  if (row.showMenu) {
    return (
      <div ref={menuRef} className={style.menu_legi}>
         {/* <DodajNowyElement row={row}  /> */}
         <DodajArkusz row={row}  />
        <Ponumeruj row={row} />

                <button
                  className={style.menu_legi_btn}
                  onClick={() => {

      createProcesyFromArkuszONE()
        setShowProcesy(true)

                    setElementyTech(elementyTech.map((t) => {
                      return {...t,
                        showMenu: false}
                    }));
         
                  }}
                >
    < GitBranchPlus size={18} style={{color:'rgba(168, 133, 16, 0.9)',marginRight:'10px',marginLeft:'4px'}}/> 

                Dodaj procesy
                </button>

        <KopiujFormatPapieru row={row} />
        <KopiujNadkomplet row={row} />

        
        <Anuluj  row={row}/>

      </div>
    );
  }
}

const Ponumeruj = ({ row}) =>{
  const techContext = useContext(TechnologyContext);

  const elementyTech = techContext.elementyTech;
  const setElementyTech = techContext.setElementyTech;
  const setArkusze = techContext.setArkusze;
  const arkusze = techContext.arkusze;
  const legi = techContext.legi;
  const setLegi = techContext.setLegi;
  return(
    <button
    className={style.menu_legi_btn}
    onClick={() => {

      // setNumerArkusza2(row)
      ponumerArkusze(row,setArkusze,arkusze,legi,setLegi)
      setElementyTech(elementyTech.map((t) => {
        return {...t,
          showMenu: false}
      }));

    }}
  >
    < ListOrdered size={18} style={{color:'rgba(25, 151, 255, 0.9)',marginRight:'10px',marginLeft:'4px'}}/> 

    Ponumeruj
  </button>
  )
}

const KopiujFormatPapieru = ({ row}) =>{
  const techContext = useContext(TechnologyContext);
  const setArkusze = techContext.setArkusze;
  const arkusze = techContext.arkusze;
  const setElementyTech = techContext.setElementyTech;
  const elementyTech = techContext.elementyTech;

  return(
    <button
    className={style.menu_legi_btn}
    onClick={() => {

// setArkusze(
//   arkusze.map((arkusz) => {
//     if (arkusz.element_id === row.id) {
//       return {
//         ...arkusz,
//         arkusz_szerokosc: row.arkusz_szerokosc,
//         arkusz_wysokosc: row.arkusz_wysokosc,
//         update: true

//       };
//     } else {
//       return arkusz;
//     }
//   })
// );

setArkusze(prevArkusze => 
  prevArkusze.map((arkusz) => {
    if (arkusz.element_id === row.id) {
      return {
        ...arkusz,
        arkusz_szerokosc: row.arkusz_szerokosc,
        arkusz_wysokosc: row.arkusz_wysokosc,
        update: true
      };
    }
    return arkusz;
  })
);



// setElementyTech(elementyTech.map((t) => {
//   return {...t,
//     showMenu: false}
// }));


setElementyTech(currentTech => 
    currentTech.map(t => ({ ...t, showMenu: false }))
  );

    }}
  >

    < Sparkles size={18} style={{color:'rgba(221, 44, 12, 0.9)',marginRight:'10px',marginLeft:'4px'}}/> 

    Rozdaj format papieru ark.
  </button>
  )
}

const KopiujNadkomplet = ({ row}) =>{
  const techContext = useContext(TechnologyContext);
  const setArkusze = techContext.setArkusze;
  const arkusze = techContext.arkusze;
  const setElementyTech = techContext.setElementyTech;
  const elementyTech = techContext.elementyTech;

  return(
    <button
    className={style.menu_legi_btn}
    onClick={() => {

setArkusze(
  arkusze.map((arkusz) => {
    if (arkusz.element_id === row.id) {
      return {
        ...arkusz,
        nadkomplet: row.nadkomplet,
        update: true

      };
    } else {
      return arkusz;
    }
  })
);
setElementyTech(elementyTech.map((t) => {
  return {...t,
    showMenu: false}
}));

    }}
  >

    < Sparkles size={18} style={{color:'rgba(81, 79, 218, 0.9)',marginRight:'10px',marginLeft:'4px'}}/> 

    Rozdaj nadkomplet
  </button>
  )
}




const Anuluj = ( ) =>{
  const techContext = useContext(TechnologyContext)
  const elementyTech = techContext.elementyTech;
  const setElementyTech = techContext.setElementyTech;
  return(
    <button
    className={style.menu_legi_btn}
    onClick={() => {
      setElementyTech(elementyTech.map((t) => {
        return {...t,
          showMenu: false}
      }));

    }}
  >
    Anuluj
  </button>
  )
}


const DodajArkusz= ({ row }) =>{
  const [dodajArkusz] = useArkuszeOne()
  return(
    <button
    className={style.menu_legi_btn}
    onClick={() => {
         dodajArkusz(row)
    }}
  >
    < CirclePlus size={18} style={{color:'rgba(95, 216, 14, 0.9)',marginRight:'10px',marginLeft:'4px'}}/> 
    Nowy arkusz
  </button>
  )
}


